import api from '../../../services/Api';
import { IAuditoriaDuplicidadePagamentosResultado } from '../interfaces/IAuditoriaDuplicidadePagamentos';

export const AuditoriaDuplicidadePagamentosService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaDuplicidadePagamentosResultado> {
    const response = await api.get<IAuditoriaDuplicidadePagamentosResultado>('auditoria-duplicidade-pagamentos/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFinanceiroTotal: 0,
        totalErros: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalLancamentosAnalisados: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        fundamentacaoFiscal: '',
        duplicidades: [],
      }
    );
  },
};
